import React, { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { CheckCircle2, Instagram, MailCheck } from 'lucide-react';
import { GiveawayBrandFrame } from '../components/GiveawayBrandFrame';
import { giveawayApi } from '../lib/giveaway-api';
import { GiveawayFollowRequirement } from '../components/GiveawayFollowRequirement';

export default function GiveawayConfirm() {
  const { slug } = useParams();
  const [token] = useState(() => window.__giveawayConfirmationToken || '');
  const [data, setData] = useState(null);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const check = useCallback(async commit => {
    setBusy(true); setError('');
    try {
      const result = await giveawayApi(`/giveaway/${slug}/${commit ? 'confirm' : 'confirmation'}`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ token }) });
      setData(result);
      if (result.confirmed) delete window.__giveawayConfirmationToken;
    } catch (err) { setError(err.message); }
    finally { setBusy(false); }
  }, [slug, token]);
  useEffect(() => {
    giveawayApi(`/giveaway/${slug}`).then(result => setData(current => current || { brand: result.brand, confirmed: false })).catch(() => {});
    if (token) check(false); else setError('Open the confirmation link from your email.');
  }, [slug, token, check]);
  return <GiveawayBrandFrame brand={data?.brand}>
    <section className="giveaway-state">
      {data?.confirmed ? <>
        <CheckCircle2 size={44} /><h1 data-testid="giveaway-confirm-success">{data.test ? 'Test email confirmed.' : 'You’re entered!'}</h1>
        {data.test && <p data-testid="giveaway-email-test-notice">Delivery test only. No giveaway entry or QR scan was recorded.</p>}
        <GiveawayFollowRequirement brand={data.brand} />
        <p data-testid="giveaway-winner-announcement">Follow us so you don’t miss the winner announcement. Winners are announced on Instagram and notified by email.</p>
        <a className="giveaway-primary" href={`https://instagram.com/${data.brand.instagram_handle}`} data-testid="giveaway-instagram-follow-button"><Instagram size={20} /> Follow @{data.brand.instagram_handle} on Instagram</a>
      </> : <>
        <MailCheck size={44} /><h1>Confirm your entry.</h1>
        <p>Confirm your email to enter {data?.brand?.name || 'the'} monthly giveaway.</p>
        {error && <p className="giveaway-error" role="alert" data-testid="giveaway-confirm-error">{error}</p>}
        {token && <button className="giveaway-primary" disabled={busy} onClick={() => check(true)} data-testid="giveaway-confirm-button">{busy ? 'Please wait…' : 'Confirm my entry'}</button>}
      </>}
    </section>
  </GiveawayBrandFrame>;
}